import PositionSkillForm, { positionSkillMap } from './PositionSkillForm';

export default PositionSkillForm;
export { positionSkillMap };
